module.exports = __webpack_public_path__ + "media/assets/svgs/settings-f9b529139ec77937b1305bd0f4f2584f.svg";